import * as React from 'react';
import { Row, Button, Tabs, Tab } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { flow, filter } from 'lodash';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { IAuthState } from '../../../../services/auth/models';
import { actions as authActions, IAuthActions } from '../../../../services/auth/reducer';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import { actions as brandingActions } from '../../../../services/branding/reducer';
import { IQuoteActions } from '../../../../services/quote/models';
import { IBrandingActions } from '../../../../services/branding/models';
import { reset, destroy } from 'redux-form';
import Loading from '../../../../components/Loading';
import { withJob } from 'react-jobs';
import * as moment from 'moment';
import Helmet from 'react-helmet';
import { IPolicyApplication } from '../../../../data/api/models';

interface IAccountSummaryProps {
  auth: IAuthState;
  actions: {
    push: (route: string) => void;
    auth: IAuthActions;
    branding: IBrandingActions,
    quote: IQuoteActions;
    reset(formName: string);
    destroy(formName: string);
  };
}

class AccountSummary extends React.Component<IAccountSummaryProps> {
  private renderPolicyData = (cell, row) => {
    return (
      <Link to={`/account/policies/${row.id}`}>
        {cell}
      </Link>
    );
  }

  private renderQuoteData = (cell, row) => {
    return (
      <Link to={`/account/quotes/${row.id}`}>
        {cell}
      </Link>
    );
  }

  private renderRenewalsData = (cell, row) => {
    return (
      <Link to={`/account/renewals/${row.id}`}>
        {cell}
      </Link>
    );
  }

  private renderQuoteDataEndDate = (cell, row) => {
    if (row.tripType === 'annual' && !cell) {
      const invertDate = row.startDate.split(/\//).reverse().join('/');
      const endDate = moment(`${invertDate}`).add('1', 'years').subtract('1', 'days').format('DD/MM/YYYY');

      return (
        <Link to={`/account/quotes/${row.id}`}>
          {endDate}
        </Link>
      );
    }

    return (
      <Link to={`/account/quotes/${row.id}`}>
        {cell}
      </Link>
    );
  }

  private handleGetNewQuote = () => {
    const { actions } = this.props;

    actions.destroy('quote');
    actions.quote.reset();
    actions.quote.loadDestinations();
    actions.push('/');
  }

  public render() {
    const { auth, actions } = this.props;

    const policyApplications = filter(
      auth.customer.policyApplications,
      (application: IPolicyApplication) => {
          return application.quoteType !== 'renewal'
            && application.quoteType !== 'mid term adjustment';
      },
    );

    return (
      <Row className="page-container">
        <Helmet>
          <title>Account Summary</title>
        </Helmet>
        <div className="customer-section-title">
          <h1>Welcome {auth.customer.firstName}.</h1>
          <div className="customer-header-box">
            <h4>
              You are through to your personal account where it is quick and convenient to
              manage your policy(ies) and quote(s) online.
            </h4>
              <ul>
                <li>
                  Click <strong>'Quotes'</strong> to view your saved quote(s); then click on the relevant
                  'Reference' number where you can view or edit your quote and purchase a policy.
                </li>
                <li>
                  Click <strong>'Policies'</strong> and then your 'Reference' number to view or download
                  your documents whenever you need them.
                </li>
              </ul>

          </div>
        </div>
        <Tabs defaultActiveKey={1} id="your-account-tabs" className="your-account-tabs">
          <Tab eventKey={1} title="Quotes">
            <div className="white-section customer-table">
              <BootstrapTable
                data={policyApplications}
              >
                <TableHeaderColumn
                  dataField="quoteReference"
                  isKey={true}
                  width="20%"
                  dataSort={true}
                  dataFormat={this.renderQuoteData}
                >
                  Reference
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="insured"
                  width="20%"
                  dataSort={true}
                  dataFormat={this.renderQuoteData}
                >
                  Lead name
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="startDate"
                  width="20%"
                  dataSort={true}
                  dataFormat={this.renderQuoteData}
                >
                  Starts
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="endsAt"
                  width="20%"
                  dataSort={true}
                  dataFormat={this.renderQuoteDataEndDate}
                >
                  Ends
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="status"
                  width="20%"
                  dataSort={true}
                  dataFormat={this.renderQuoteData}
                >
                  Status
                </TableHeaderColumn>
              </BootstrapTable>
            </div>
          </Tab>
          <Tab eventKey={2} title="Policies">
            <div className="white-section customer-table">
              <BootstrapTable data={auth.customer.policies}>
                <TableHeaderColumn
                  dataField="policyNumber"
                  isKey={true}
                  width="20%"
                  dataSort={true}
                  dataFormat={this.renderPolicyData}
                >
                  Reference
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="insured"
                  width="20%"
                  dataSort={true}
                  dataFormat={this.renderPolicyData}
                >
                  Lead name
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="commencesAt"
                  width="20%"
                  dataSort={true}
                  dataFormat={this.renderPolicyData}
                >
                  Starts
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="expiresAt"
                  width="20%"
                  dataSort={true}
                  dataFormat={this.renderPolicyData}
                >
                  Ends
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="status"
                  width="20%"
                  dataSort={true}
                  dataFormat={this.renderPolicyData}
                >
                  Status
                </TableHeaderColumn>
              </BootstrapTable>
            </div>
          </Tab>
          {auth.customer.renewals.length > 0 && (
            <Tab eventKey={3} title="Renewals">
              <div className="white-section customer-table">
                <BootstrapTable
                  data={auth.customer.renewals}
                >
                  <TableHeaderColumn
                    dataField="quoteReference"
                    isKey={true}
                    width="20%"
                    dataSort={true}
                    dataFormat={this.renderRenewalsData}
                  >
                    Reference
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="insured"
                    width="20%"
                    dataSort={true}
                    dataFormat={this.renderRenewalsData}
                  >
                    Insured
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="startDate"
                    width="20%"
                    dataSort={true}
                    dataFormat={this.renderRenewalsData}
                  >
                    Starts
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="endDate"
                    width="20%"
                    dataSort={true}
                    dataFormat={this.renderRenewalsData}
                  >
                    Ends
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="status"
                    width="20%"
                    dataSort={true}
                    dataFormat={this.renderRenewalsData}
                  >
                    State
                  </TableHeaderColumn>
                </BootstrapTable>
              </div>
            </Tab>)
          }
        </Tabs>
        <div className="btn-bar">
          {/*<Button
            bsStyle="default"
            type="submit"
            bsSize="lg"
          >
            CHANGE PASSWORD
          </Button>*/}
          <Button
            bsStyle="default"
            type="submit"
            onClick={actions.auth.logout}
          >
            LOG OUT
          </Button>
          <Button
            bsStyle="primary"
            className="pull-right"
            onClick={this.handleGetNewQuote}
          >
            NEW QUOTE
          </Button>
        </div>
      </Row>
    );
  }
}

export default flow([
  // reduxForm({
  //   form: 'quote',
    // destroyOnUnmount: true,
    // forceUnregisterOnUnmount: true,
  // }),
  withJob({
    work: (props: IAccountSummaryProps) => {
      const promises = [];

      promises.push(props.actions.auth.reloadCustomer());

      return Promise.all(promises);
    },
    LoadingComponent: (props) => <Loading/>,
    ErrorComponent: ({ error }) => {
      console.error(error);

      return (
        <div>
          {error.message}
        </div>
      );
    },
  }),
  connect(
    (state) => {
      return {
        auth: state.auth,
        quote: state.quote,
        branding: state.branding,
      };
    },
    (dispatch) => ({
      actions: {
        auth: bindActionCreators({...authActions}, dispatch),
        push: bindActionCreators(push, dispatch),
        reset: bindActionCreators(reset, dispatch),
        destroy: bindActionCreators(destroy, dispatch),
        quote: bindActionCreators({ ...quoteActions }, dispatch),
        branding: bindActionCreators({ ...brandingActions }, dispatch),
      },
    }),
  ),
])(AccountSummary);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/CustomerArea/scenes/AccountSummary/index.tsx